module.exports = __webpack_public_path__ + "static/media/food_6.64f81e88.jpeg";